import ApplicantManual from '@/components/services/DocumentConversion/Applicant/Manual/index.vue';

import ConversionDocument from '@/components/services/DocumentConversion/ConversionDocument.vue';
import DocumentConversionDetails from '@/components/services/DocumentConversion/DocumentConversionDetails.vue';
import AccountBankDetails from '@/components/services/DocumentConversion/AccountBankDetails.vue';
import StepDocuments from '@/components/services/common/StepDocuments.vue';

import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType.vue';
import SubjectFillType from '@/components/services/common/SubjectFillType.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const commonSteps: unknown[] = [
  ConversionDocument,
  DocumentConversionDetails,
  AccountBankDetails,
  StepDocuments,
];
const steps: unknown[] = [ApplicantManual, ...commonSteps];

const mrpaSteps: unknown[] = [
  SelectSubjectFillType,
  SubjectFillType,
  ...commonSteps,
];

export const documentConversionSteps: unknown[] = isMrpaEnable(
  StatementType.DOCUMENT_CONVERSION
)
  ? mrpaSteps
  : steps;
